import { memo, useEffect } from 'react'

import { CircularProgress, IconButton } from '@material-ui/core'

import { ViewAnalyticsDialog } from './ViewAnalyticsDialog'
import { ReactComponent as InsightsIcon } from 'assets/icons/menu/icon-insights.svg'

import { useAuth, useBoolean, useRoles } from 'hooks'
import { PlaybookType } from 'app/types'

type Props = {
    playbookId: string
    isOwner: boolean
    playbook: PlaybookType
    isOpen?: boolean
    hideButton?: boolean
    onClose?: () => void
}

export const PlaybookAnalytics = memo(
    ({ playbookId, isOwner, isOpen = false, onClose, playbook, hideButton }: Props) => {
        const { isContentManager, isAdmin, isSuperAdmin } = useRoles()
        const { orgId } = useAuth()

        const showDialog = useBoolean()
        const loading = useBoolean()

        const setShowDialog = showDialog.set
        useEffect(() => {
            setShowDialog(isOpen)
        }, [isOpen, setShowDialog])

        // users from another orgs shouldn't see the analytic
        if (orgId !== playbook.uploadedByOrgId && !isSuperAdmin) return null

        if (!isOwner && !isContentManager && !isAdmin) return null

        return (
            <>
                {!hideButton && (
                    <>
                        {loading.isTrue ? (
                            <CircularProgress size={20} />
                        ) : (
                            <IconButton
                                size="small"
                                style={{ color: 'black' }}
                                onClick={showDialog.setTrue}
                                title="View Analytics"
                                data-cy="analytics-button"
                            >
                                <InsightsIcon />
                            </IconButton>
                        )}
                    </>
                )}

                <ViewAnalyticsDialog
                    isOpen={showDialog.isTrue}
                    onClose={() => {
                        showDialog.setFalse()
                        onClose?.()
                    }}
                    playbookId={playbookId}
                    playbook={playbook}
                    setLoading={loading.set}
                />
            </>
        )
    }
)
